import { apiSlice } from '../api/apiSlice'

export type VacationDay = {
  date: string
  description: string | null
  hours: number
}

export type MonthlySummary = {
  work: number
  usedOvertime: number
  vacationDays: VacationDay[]
  vacationPaid: number
  vacationUnpaid: number
}

export type YearlySummary = {
  [key: number]: MonthlySummary
  paidVacationHours: number
}

type GetYearlySummaryArgs = {
  id: string
  year: number
}

export const yearlySummaryApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getYearlySummary: builder.query<YearlySummary, GetYearlySummaryArgs>({
      query: ({ id, year }) => ({
        url: `/yearly-summary/${id}?year=${year}`,
        method: 'GET',
      }),
      providesTags: () => [{ type: 'YearlySummary', id: 'LIST' }],
    }),
  }),
})

export const { useGetYearlySummaryQuery } = yearlySummaryApiSlice
